<script>

export default {
  name: 'SidebarContainer',
  props: ['brand', 'isSidebarCollapsed', 'isSidebarHidden', 'forceSidebarHidden'],
}
</script>
<template>
  <aside
    id="sidebar"
    class="tw-h-[calc(100vh-58px)] tw-mt-[58px] tw-transition-all tw-shrink-0 tw-absolute lg:tw-relative tw-z-[99] tw-w-64 lg:tw-left-0 tw-shadow-[0_0_5px_rgb(0,0,0,.13)]"
    style="clip-path: inset(0 -200px 0 0);"
    :class="[
      isSidebarCollapsed && forceSidebarHidden ? 'lg:tw-w-0 ' : '',
      isSidebarCollapsed && !isSidebarHidden && !forceSidebarHidden ? 'lg:tw-w-[68px] ' : '',
      isSidebarHidden ? 'tw--left-64 ' : 'tw-left-0',
    ]"
  >
    <div class="tw-h-full tw-w-full tw-top-0 tw-left-0 tw-transition-color tw-bg-white dark:tw-bg-[#081825] tw-border-t dark:tw-border-t-[#1E364A]">
        <div class="tw-flex tw-flex-col tw-right-0 tw-bottom-0 tw-h-full tw-no-scrollbar tw-overflow-y-auto tw-overflow-x-hidden tw-pb-10 tw-pt-[10px] lg:tw-pt-0" data-simplebar>

          <slot />

        </div>
      </div>
  </aside>
</template>

<style type="text/css">
@import './sidebar.css';
</style>
